import {
    Accordion,
    AccordionContent,
    AccordionItem,
    AccordionTrigger,
} from "@/components/ui/accordion";
import { Reveal, Eyebrow } from "./Reveal";

const FAQS = [
    {
        id: "faq-item-condo-approval",
        q: "Preciso de aprovação do condomínio para instalar?",
        a: "Para áreas comuns, normalmente sim — a instalação passa pelo síndico ou pela assembleia. Preparamos a proposta técnica completa para facilitar essa aprovação. Em residências, é só combinar o dia.",
    },
    {
        id: "faq-item-power-backup",
        q: "O sistema continua funcionando se faltar energia?",
        a: "Sim. Projetamos opcionalmente com nobreak dedicado, mantendo câmeras, gravador e portões operando durante quedas de energia.",
    },
    {
        id: "faq-item-night-vision",
        q: "As câmeras enxergam bem à noite?",
        a: "Trabalhamos com câmeras com visão noturna por infravermelho e tecnologia colorida noturna, escolhidas conforme a iluminação real de cada ponto do local.",
    },
    {
        id: "faq-item-facial-dark",
        q: "O reconhecimento facial funciona de noite ou com chuva?",
        a: "Os leitores faciais que instalamos têm iluminação própria e algoritmos preparados para variações de luz e clima, mantendo a leitura rápida em qualquer condição.",
    },
    {
        id: "faq-item-warranty",
        q: "Como funciona a garantia?",
        a: "Toda instalação sai com termo de garantia da nossa mão de obra, além da garantia de fábrica dos equipamentos, com suporte direto pelo WhatsApp.",
    },
];

const Faq = () => (
    <section id="faq" className="relative py-24 lg:py-32">
        <div className="mx-auto max-w-3xl px-5 lg:px-8">
            <Reveal className="mb-12 text-center">
                <Eyebrow>[ 06 — FAQ ]</Eyebrow>
                <h2 className="mt-4 font-display text-3xl sm:text-4xl font-bold tracking-tight leading-[1.05] text-white">
                    Perguntas frequentes
                </h2>
            </Reveal>

            <Reveal delay={0.1}>
                <div data-testid="faq-accordion-wrapper">
                    <Accordion type="single" collapsible className="w-full">
                        {FAQS.map((f, i) => (
                            <AccordionItem
                                key={f.id}
                                value={`item-${i}`}
                                data-testid={f.id}
                                className="border-white/10"
                            >
                                <AccordionTrigger className="text-left font-display text-base sm:text-lg font-semibold text-slate-100 hover:text-volt hover:no-underline py-6">
                                    <span className="flex items-start gap-4">
                                        <span className="font-hud text-xs text-volt mt-1.5">
                                            0{i + 1}
                                        </span>
                                        {f.q}
                                    </span>
                                </AccordionTrigger>
                                <AccordionContent className="text-sm leading-relaxed text-slate-400 pl-8">
                                    {f.a}
                                </AccordionContent>
                            </AccordionItem>
                        ))}
                    </Accordion>
                </div>
            </Reveal>
        </div>
    </section>
);

export default Faq;
